<script setup>
import { getDate, getShortMonth, getYear } from "~/modules/helpers/day";

const route = useRoute();

const { $get } = useAxios();

const { data: news, pending: isNewsLoaded } = await useAsyncData(
  `get news by id - ${route.params.id}`,
  () => $get(`/api/v3/news/${route.params.id}`)
);

const { data: newsList } = await useAsyncData("get the lastest 20 news", () =>
  $get("/api/v3/news?_limit=20")
);

const head = computed(() => {
  return {
    title: `${news.value?.name} | Государственный русский театр драмы им. Ф. А. Искандера`,
    meta: [
      {
        hid: "title",
        property: "title",
        content: `${news.value?.name} | Государственный русский театр драмы им. Ф. А. Искандера`,
      },
      {
        hid: "og:title",
        property: "og:title",
        content: `${news.value?.name} | Государственный русский театр драмы им. Ф. А. Искандера`,
      },
      {
        hid: "url",
        name: "url",
        content: `https://rusdram.org/news/${news.value?._id}`,
      },
      {
        hid: "og:url",
        property: "og:url",
        content: `https://rusdram.org/news/${news.value?._id}`,
      },
      {
        hid: "image",
        name: "image",
        content: `https://ucarecdn.com/${news.value?.img.fileKey}/-/quality/smart/image.png`,
      },
      {
        name: "og:image",
        property: "og:image",
        content: `https://ucarecdn.com/${news.value?.img.fileKey}/-/quality/smart/image.png`,
      },
    ],
  };
});

useHead(head);
</script>

<template>
  <nuxt-layout name="default">
    <div v-if="!isNewsLoaded">
      <div v-if="news">
        <r-section>
          <div class="flex flex-row flex-nowrap gap-x-10 relative">
            <button
              @click="$router.go(-1)"
              class="flex flex-row justify-items-center focus:outline-none"
            >
              <span class="text-light-gray text-2xl pt-1/2">
                <RIcon class="h-4 w-2" icon="angle-left" />
              </span>
              <span class="pl-4 pb-px -mt-1 text-light-gray text-xl"
                >Все новости</span
              >
            </button>
          </div>
          <div class="mt-12 w-full overflow-hidden rounded-lg h-120">
            <img
              class="w-full h-full object-cover"
              :src="`https://ucarecdn.com/${news.img.fileKey}/-/format/auto/-/quality/smart/image.png`"
              :alt="news.name"
            />
          </div>

          <div class="mt-8 w-full flex flex-col">
            <h1 class="font-size text-4xl text-dark-gray">{{ news.name }}</h1>
            <p class="text-primary font-sans text-lg">
              {{ getDate(news.createdAt) }}
              {{ getShortMonth(news.createdAt) }}
              {{ getYear(news.createdAt) }}
            </p>
          </div>
          <div class="mt-8 w-full text-left detail" v-html="news.text"></div>
          <RShare class="mt-8"></RShare>
        </r-section>
        <r-news-main-page :news="newsList" v-if="newsList"></r-news-main-page>
      </div>
    </div>
    <r-full-page-pro-loader v-else></r-full-page-pro-loader>
  </nuxt-layout>
</template>

<style scoped>
.detail {
  columns: 2;
  column-gap: 28px;
}
@media screen and (max-width: 1280px) {
  .detail {
    columns: 1;
  }
}

.detail >>> * {
  color: #707070 !important;
}

.detail >>> a strong {
  color: #83040e !important;
}
</style>
